module.exports = __webpack_public_path__ + "img/circular-personal-loan.380e0319.png";